import { EMPTY_ESTIMATED_UNBILL_FIGURE_ENTITY, EstimatedUnbillFigureEntity } from "domain/entity/EstimatedUnbillFigure/EstimatedUnbillFigureEntity";
import { BaseViewChangeSate } from "../BaseViewChangeState";


export interface EstimatedUnbillFigureViewChangeState extends BaseViewChangeSate {
}

export interface EstimatedUnbillFigureModel {
    isLoading: boolean,
    isShowEditPanel: boolean,
    isAdd: boolean,
    isEdit: boolean,
    tableList: EstimatedUnbillFigureEntity[],
    currentRow: EstimatedUnbillFigureEntity,
    editingEntity: EstimatedUnbillFigureEntity,
    masterState: EstimatedUnbillFigureViewChangeState,

}

export const EMPTY_ESTIMATED_UNBILL_FIGURE_MODEL: EstimatedUnbillFigureModel = {
    isLoading: false,
    isShowEditPanel: false,
    isAdd: false,
    isEdit: false,
    tableList: [],
    currentRow: { ...EMPTY_ESTIMATED_UNBILL_FIGURE_ENTITY },
    editingEntity: { ...EMPTY_ESTIMATED_UNBILL_FIGURE_ENTITY },
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        }
    }
}